import { render, staticRenderFns } from "./ContatosHotel.vue?vue&type=template&id=9714cf30&scoped=true"
import script from "./ContatosHotel.vue?vue&type=script&lang=js"
export * from "./ContatosHotel.vue?vue&type=script&lang=js"
import style0 from "./ContatosHotel.vue?vue&type=style&index=0&id=9714cf30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9714cf30",
  null
  
)

export default component.exports